import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppWindow } from 'lucide-react';
import { useApplications, APP_ICON_MAP, APP_COLOR_MAP } from '../hooks/useApplications';

export default function PinnedAppsHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pinnedApplications } = useApplications();

  if (!pinnedApplications || pinnedApplications.length === 0) {
    return null;
  }

  return (
    <div className="pinned-apps-header-row" role="group" aria-label="Pinned Applications">
      {pinnedApplications.map((app) => {
        const IconComponent = APP_ICON_MAP[app.slug] || APP_ICON_MAP[app.icon] || AppWindow;
        const brandColor = app.color || APP_COLOR_MAP[app.slug] || '#3b82f6';
        const isPasswordVaultRoute =
          location.pathname === '/apps/passwords' ||
          location.pathname === '/vault' ||
          location.pathname.startsWith('/vault/') ||
          location.pathname === '/categories' ||
          location.pathname.startsWith('/categories/') ||
          location.pathname === '/generator' ||
          location.pathname.startsWith('/generator/') ||
          location.pathname.startsWith('/shares') ||
          location.pathname.startsWith('/teams');

        const isActive = app.slug === 'passwords'
          ? isPasswordVaultRoute
          : (location.pathname === `/apps/${app.slug}` || location.pathname.startsWith(`/apps/${app.slug}/`));

        return (
          <button
            key={app.id || app.slug}
            type="button"
            className={`pinned-app-chip ${isActive ? 'active' : ''}`}
            onClick={() => navigate(app.slug === 'passwords' ? '/vault' : `/apps/${app.slug}`)}
            title={`Open ${app.name}`}
            aria-label={app.name}
          >
            <div
              className="pinned-app-chip-icon"
              style={{
                color: brandColor,
                background: isActive ? `${brandColor}24` : 'transparent',
              }}
            >
              <IconComponent size={16} />
            </div>
            <span className="pinned-app-chip-label">{app.name}</span>
          </button>
        );
      })}
    </div>
  );
}
